import { Images } from 'octiv-assets';
import { Box, Image, Table, Text } from 'octiv-components';
import { getAddressString } from 'octiv-utilities/Functions';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default ({ data, query, isLoading, onClickAction, ...props }) => {
  const { t } = useTranslation();
  const iconSize = 4;

  const tableData = useMemo(() => data || [], [data]);
  const tableColumns = useMemo(
    () => [
      {
        Header: t('locationName'),
        accessor: 'name',
        Cell: ({ row: { original } }) => {
          const healthProviders =
            data.find((item) => item.id === original.id)?.healthProviders || [];
          const locationHasHealthProviders = !!(
            original.id && healthProviders[0]
          );

          return (
            <Box alignItems='center' display='flex' flexDirection='row'>
              {locationHasHealthProviders && (
                <Image
                  alt={t('discoveryLogo')}
                  backgroundSize='contain'
                  height={iconSize}
                  mr={1}
                  src={Images.vitalityLogomark}
                  width={iconSize}
                />
              )}
              <Text>{original.name}</Text>
            </Box>
          );
        },
      },
      {
        Header: t('locationId'),
        accessor: 'id',
        Cell: ({ value }) => value,
      },
      {
        Header: t('tenantName'),
        accessor: 'tenant.name',
        Cell: ({ value }) => value,
      },
      {
        Header: t('tenantId'),
        accessor: 'tenant.id',
        Cell: ({ value }) => value,
      },
      {
        Header: t('address'),
        accessor: 'address',
        Cell: ({ value }) => getAddressString(value),
      },
    ],
    [data, t]
  );

  return (
    <Table
      {...props}
      columns={tableColumns}
      data={tableData}
      isLoading={isLoading}
    />
  );
};
